// extracted by mini-css-extract-plugin
module.exports = {"TextArea":"ReviewForm_TextArea__1-wrY"};